"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _frames = require("./frames");

var setObserverOptions = function setObserverOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? null : _ref$root,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px' : _ref$rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 1 : _ref$threshold;

  return {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  };
};

var setAllOptions = function setAllOptions(_ref2) {
  var selector = _ref2.selector,
      threshold = _ref2.threshold,
      animation = _ref2.animation,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? 1000 : _ref2$duration,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 0 : _ref2$delay,
      _ref2$easing = _ref2.easing,
      easing = _ref2$easing === void 0 ? 'linear' : _ref2$easing,
      _ref2$once = _ref2.once,
      once = _ref2$once === void 0 ? true : _ref2$once,
      _ref2$waterfall = _ref2.waterfall,
      waterfall = _ref2$waterfall === void 0 ? false : _ref2$waterfall,
      _ref2$custom = _ref2.custom,
      custom = _ref2$custom === void 0 ? null : _ref2$custom;
  return {
    selector: selector,
    threshold: threshold,
    animation: animation,
    duration: duration,
    delay: delay,
    easing: easing,
    fill: 'forwards',
    once: once,
    waterfall: waterfall,
    custom: custom
  };
};

var handleInputErrors = function handleInputErrors(options) {
  if (options.threshold !== undefined && (typeof options.threshold !== 'number' || options.threshold <= 0 || options.threshold > 1)) {
    throw new Error('Threshold should be a number between 0 exclusive and 1 inclusive');
  }
};

var setEvents = function setEvents() {
  var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    "in": new CustomEvent('intersecta:in', {
      detail: details
    }),
    out: new CustomEvent('intersecta:out', {
      detail: details
    })
  };
};

var handleEntry = function handleEntry(entry, observer, entryIndex, options, events) {
  var animationOptions = function (_ref3) {
    var duration = _ref3.duration,
        fill = _ref3.fill,
        delay = _ref3.delay,
        easing = _ref3.easing;
    return {
      duration: duration,
      fill: fill,
      delay: delay,
      easing: easing
    };
  }(options); // if custom animation, use custom


  var animation = options.custom ? options.custom : _frames.frames[options.animation || 'fadeIn'];

  if (entry.isIntersecting && entry.intersectionRatio.toFixed(1) >= (options.threshold ? options.threshold.toFixed(1) : 1)) {
    // if waterfall is selected, add selected or default delay
    if (options.waterfall) {
      if (animationOptions.delay) {
        animationOptions.delay *= entryIndex;
      } else {
        animationOptions.delay = entryIndex * 100;
      }
    } // trigger in event


    entry.target.dispatchEvent(events["in"]); // start animation

    entry.target.animate( // keyframes
    animation, // timing options
    animationOptions); // when enabled, remove observer after effect played once

    if (options.once || _frames.onceOnlyFrames.has(animation)) observer.unobserve(entry.target);
  } else {
    // trigger out event
    entry.target.dispatchEvent(events.out); // reverse animation if it depends on opacity property

    entry.target.animate( // keyframes
    animation, // timing options
    {
      direction: 'reverse',
      fill: 'forwards',
      duration: 1
    });
  }
};

var intersecta = function intersecta(userOptions) {
  // handle wrong user inputs
  handleInputErrors(userOptions); // set events, options, items and callback

  var events = setEvents();
  var options = setAllOptions(userOptions);
  var selectItems = document.querySelectorAll(options.selector);

  var intersectionEffect = function intersectionEffect(entries, obs) {
    entries.forEach(function (entry, index) {
      return handleEntry(entry, obs, index, options, events);
    });
  }; // start observer


  var observer = new IntersectionObserver(intersectionEffect, setObserverOptions(options));
  selectItems.forEach(function (t) {
    return observer.observe(t);
  });
  return {
    stop: function stop() {
      observer.disconnect();
    }
  };
};

var _default = intersecta;
exports["default"] = _default;